<template>
  <div class="divide-y divide-white/15" role="tablist" aria-multiselectable="true">
    <slot />
  </div>
</template>
